import { __decorate } from "tslib";
import { AsnProp, AsnPropTypes } from "@peculiar/asn1-schema";
import { Extension } from "@peculiar/asn1-x509";
import { ResponderID } from "./responder_id";
import { SingleResponse } from "./single_response";
import { Version } from "./types";
export class ResponseData {
    constructor(params = {}) {
        this.version = Version.v1;
        this.responderID = new ResponderID();
        this.producedAt = new Date();
        this.responses = [];
        Object.assign(this, params);
    }
}
__decorate([
    AsnProp({ type: AsnPropTypes.Integer, context: 0, defaultValue: Version.v1 })
], ResponseData.prototype, "version", void 0);
__decorate([
    AsnProp({ type: ResponderID })
], ResponseData.prototype, "responderID", void 0);
__decorate([
    AsnProp({ type: AsnPropTypes.GeneralizedTime })
], ResponseData.prototype, "producedAt", void 0);
__decorate([
    AsnProp({ type: SingleResponse, repeated: "sequence" })
], ResponseData.prototype, "responses", void 0);
__decorate([
    AsnProp({ type: Extension, repeated: "sequence", context: 1, optional: true })
], ResponseData.prototype, "responseExtensions", void 0);
